import { updateGameFavoriteStatus } from "@/api/games";

export class GamesService {
  async updateGameFavoriteStatus(gameId: number, status: boolean): Promise<number> {
    return await updateGameFavoriteStatus(gameId, status);
  }
}

export const gamesService = new GamesService();
